import { observer } from 'mobx-react';
import GenericSortFilter from '../../../../../GenericSortFilter';
import { SearchParameter, SearchParameters } from '../../../../../../ListFilter/Types';
import { DeepLinksOptionsResource } from '../DeepLinksOptionsStore/Types';

interface Props {
  duplicateProgramDeepLinkCount: number;
  resource: DeepLinksOptionsResource;
  searchParameters: SearchParameters;
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
}

function Body({
  duplicateProgramDeepLinkCount,
  resource,
  searchParameters,
  updatingSearchParameters,
}: Props) {
  return (
    <>
      <div className="mr-3 min-w-[160px]">
        <GenericSortFilter
          placeholder="Course Type"
          options={resource.payload.programTypes}
          parameters={searchParameters}
          updatingParameters={updatingSearchParameters}
          sortFilterKey={'program_type'}
        />
      </div>
      <div className="mr-3 min-w-[280px]">
        <GenericSortFilter
          placeholder="License"
          options={resource.payload.licenses}
          parameters={searchParameters}
          updatingParameters={updatingSearchParameters}
          sortFilterKey={'license'}
        />
      </div>
      <div className="mr-3 min-w-[160px]">
        <GenericSortFilter
          placeholder="Channel"
          options={resource.payload.deliveryChannels}
          parameters={searchParameters}
          updatingParameters={updatingSearchParameters}
          sortFilterKey={'delivery_channel'}
        />
      </div>
    </>
  );
}

export default observer(Body);
